<template>
    <div class="container">
        <Row class="title-wrap">
            <Col :xs="{ span: 24}" :sm="{ span: 24}" :md="{ span: 24}" :lg="{ span: 24}">
            <div class="title">
                <img src="../../assets/images/databoard/head-left-icon.png"/>
                <span v-on:click="handleFullScreen()">{{fromTag == 1 ? '全国' : '样板'}}{{title}}分布图</span>
                <img src="../../assets/images/databoard/head-right-icon.png"/>
            </div>
            <div class="full-screen" v-on:click="handleFullScreen()">
                <template v-if="!fullscreen">
                    <span class="full-icon"><img src="../../assets/images/databoard/full-screen-icon.png"/></span>
                    <span class="full-title">全屏</span>
                </template>
                <template v-else>
                    <span class="full-icon"><img src="../../assets/images/databoard/exit-full-screen-icon.png"/></span>
                    <sp an class="full-title">取消全屏</sp>
                </template>
            </div>
            </Col>
        </Row>
        <div class="switch-bar">
            <div class="type-wrap">
                <div class="type-item" :class="typeTag===1 ? 'type-selected':''" v-on:click="changeType(1,'学校')">
                    <span>学校</span>
                </div>
                <div class="type-item" :class="typeTag===2 ? 'type-selected':''" v-on:click="changeType(2,'用户')">
                    <span>用户</span>
                </div>
            </div>

        </div>
        <div class="total-num-bar">
            <div class="total-num-wrap">
                <template v-for="(item,index) in totalNumArr">
                    <div class="num-item">
                        <ul class="list" :class="item.scrollName">
                            <li><span class="num-txt">0</span></li>
                            <li><span class="num-txt">1</span></li>
                            <li><span class="num-txt">2</span></li>
                            <li><span class="num-txt">3</span></li>
                            <li><span class="num-txt">4</span></li>
                            <li><span class="num-txt">5</span></li>
                            <li><span class="num-txt">6</span></li>
                            <li><span class="num-txt">7</span></li>
                            <li><span class="num-txt">8</span></li>
                            <li><span class="num-txt">9</span></li>
                        </ul>
                    </div>
                </template>
            </div>
        </div>
        <Row class="statistic-wrap">
            <Col :xs="{ span: 24}" :sm="{ span: 24}" :md="{ span: 24}" :lg="{ span: 24}">
            <china-map :china-data="chinaMapData"
                       :type-tag="typeTag"
                       :from-tag="fromTag"
                       @scroll-total-num="scrollTotalNum">
            </china-map>
            </Col>
        </Row>
        <Spin fix v-if="spinShow">
            <div>
                <div>加载中...</div>
            </div>
        </Spin>
    </div>
</template>

<script>
    import {findProvinceData} from "../../service/api.js";

    const chinaMap = () => import("./modules/chinaMap");

    export default {
        name: 'map-index',
        components: {
            chinaMap
        },
        computed: {},
        data () {
            return {
                fullscreen: false,
                title: '学校',
                typeTag: 1,//统计类别 1：学校 2：用户  3：活跃用户
                chinaMapData: [],
                html: '',
                totalNumArr: [],
                totalNum: 0,
                spinShow: true,//正在加载标识
                fromTag: this.$route.query.fromTag
            }
        },
        methods: {
            /**
             * 切换统计类型
             */
            changeType (type, title) {
                this.typeTag = type;
                this.title = title;
                this.totalNumArr = [];
                // 获取统计数据
                this.getChinaMapData();
            },
            /**
             * 总数滚动加载
             */
            scrollTotalNum () {
                let _this = this;
                let numArr = _this.totalNum.toString().split('');
                let tempTotalNumArr = [];
                for (let i = 0; i < numArr.length; i++) {
                    let numObj = {};
                    numObj.num = 0;
                    numObj.scrollName = '';

                    let tempNumObj = {};
                    tempNumObj.num = numArr[i];
                    tempNumObj.scrollName = 'scroll' + numArr[i];

                    _this.totalNumArr.push(numObj);
                    tempTotalNumArr.push(tempNumObj);
                }

                setTimeout(function () {
                    _this.totalNumArr = tempTotalNumArr;
                }, 500);
            },
            /**
             * 全屏
             */
            handleFullScreen () {
                let element = document.documentElement;
                if (this.fullscreen) {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                } else {
                    if (element.requestFullscreen) {
                        element.requestFullscreen();
                    } else if (element.webkitRequestFullScreen) {
                        element.webkitRequestFullScreen();
                    } else if (element.mozRequestFullScreen) {
                        element.mozRequestFullScreen();
                    } else if (element.msRequestFullscreen) {
                        // IE11
                        element.msRequestFullscreen();
                    }
                }
                this.fullscreen = !this.fullscreen;
            },
            /**
             * 获取中国地图各省 学校数 用户数
             */
            async getChinaMapData () {
                let _this = this;
                let params = {
                    type: _this.typeTag,
                    from: _this.fromTag == 1 ? '' : 'tempSchool'
                }
                let resultData = await findProvinceData(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                // _this.chinaMapData = resultData;
                //
                // if (_this.chinaMapData.length > 0) {
                //     let tempTotalNum = 0;
                //     _this.chinaMapData.filter((item) => {
                //         tempTotalNum += item.value
                //     });
                //     _this.totalNum = tempTotalNum;
                // }

                //总数滚动加载
                // _this.scrollTotalNum();

                if (resultData.length > 0) {
                    let tempTotalNum = 0;
                    resultData.filter((item) => {
                        tempTotalNum += item.value
                    });
                    _this.totalNum = tempTotalNum;
                }

                _this.chinaMapData = resultData;

                this.spinShow = false;
            }
        },
        mounted () {
            this.$nextTick(() => {
                //获取中国地图各省 学校数 用户数
                this.getChinaMapData();
            });
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../style/map";

    @font-face {
        font-family : MaravaleExpanded;
        src         : url('../../assets/fonts/digifaw.ttf');//字体路径
    }

    .container {
        background-image  : url("../../assets/images/map/map-bg.png");
        /*background-size   : cover;*/
        background-repeat : no-repeat;
        /*background-position : bottom;*/
        background-size   : 100% 100%;
    }

    .title-wrap {
        background-image    : url("../../assets/images/map/map-head-bg.png");
        background-repeat   : no-repeat;
        background-position : top;
    }

    .count-wrap {
        height            : 100%;
        background-image  : url("../../assets/images/databoard/count-bg.png");
        background-size   : 100% 100%;
        background-repeat : no-repeat;
    }

    .full-screen {
        background-image  : url("../../assets/images/databoard/full-screen-bg.png");
        background-size   : 100% 100%;
        background-repeat : no-repeat;
    }

    .bg1 {
        background-image : url("../../assets/images/databoard/title-bg1.png");
    }

    .switch-bar {
        background-image    : url("../../assets/images/map/type-bg.png");
        background-repeat   : no-repeat;
        background-position : top;
    }

    .type-selected {
        background-image  : url("../../assets/images/map/type-select-bg.png");
        background-repeat : no-repeat;
        background-size   : 100% 100%;
    }

    .num-item {
        background-image  : url("../../assets/images/map/num-bg.png");
        background-repeat : no-repeat;
        background-size   : 100% 100%;
    }

</style>

<style lang="scss">
    body {
        background-color : #000 !important;
        overflow-x       : hidden;
        overflow-y       : hidden;
    }

    .active {
        overflow-x : auto;
        overflow-y : auto;
    }

    .ivu-page-item-active {
        border-color : #29abe2;
        background   : #29abe2;
    }

    .ivu-page-item:hover {
        border-color : #29abe2;
    }

    .ivu-page-item-active a {
        color : #fff;
    }

    .ivu-page-item-active:hover a {
        color : #fff !important;
    }

    .ivu-page-item:hover a {
        color : #29abe2;
    }

    .ivu-page-next:hover, .ivu-page-prev:hover {
        border-color : #29abe2;
    }

    .ivu-page-next:hover a, .ivu-page-prev:hover a {
        color : #29abe2;
    }

    a {
        color : #29abe2;
    }

    a:hover {
        color : #29abe2;
    }
</style>
